const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0351563,0,0,0.0351563,1.99999,1.99999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509,186L456.693,116.257L458.734,101.974C459.401,97.3 457.83,92.584 454.491,89.246L422.671,57.426L454.49,25.606C460.348,19.749 460.348,10.251 454.49,4.393C448.633,-1.464 439.135,-1.464 433.277,4.393L401.458,36.213L369.638,4.393C366.3,1.054 361.584,-0.512 356.91,0.15L208.417,21.363C205.204,21.822 202.227,23.311 199.932,25.606L16.084,209.454C-5.361,230.898 -5.361,265.792 16.084,287.236L171.647,442.8C174.829,445.982 178.313,448.681 182,450.918L182,457C182,487.327 206.673,512 237,512L457,512C487.327,512 512,487.327 512,457L512,195C512,191.755 510.947,188.596 509,186ZM37.297,266.023C27.549,256.275 27.549,240.415 37.297,230.667L217.609,50.355L353.727,30.91L380.244,57.427L359.031,78.64L348.424,68.033C342.567,62.176 333.069,62.176 327.211,68.033C321.353,73.89 321.353,83.388 327.211,89.246L369.638,131.673C372.567,134.602 376.406,136.067 380.244,136.067C384.082,136.067 387.922,134.602 390.85,131.673C396.708,125.816 396.708,116.318 390.85,110.46L380.243,99.853L401.456,78.64L427.973,105.157L408.527,241.275L228.216,421.587C223.494,426.309 217.216,428.909 210.538,428.909C203.86,428.909 197.582,426.308 192.86,421.587L37.297,266.023ZM482,457C482,470.785 470.785,482 457,482L237,482C223.836,482 213.024,471.772 212.075,458.846C225.642,458.47 239.097,453.132 249.428,442.8L433.276,258.952C435.571,256.657 437.06,253.68 437.519,250.467L450.692,158.257L482,200L482,457Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.2d4db652a7d9abf5d663e84521877e62.svg";
export { ForwardRef as ReactComponent };